import request from "./request";

export async function getBusinessIncomeTotal(params = {}) {
  return await request.get("/spin/dataBusiness/getBusinessIncomeTotal", {
    params,
  });
}

export async function getBusinessIncomeTotalApp(params = {}) {
  return await request.get("/spin/dataBusiness/getBusinessIncomeTotalApp", {
    params,
  });
}


